<template>
    <b-modal v-if="!loading" id="product_unit_form" ref="product_unit_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add Product Units' : 'Edit Product Units' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Base Unit" class="has-float-label">
                        <template v-slot:label>
                            <span>Base Unit <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateProductUnits" v-model="selected.unit" :options="units"
                                  :border-danger="'unit' in errors"/>

                        <b-form-invalid-feedback :state="!'unit' in errors"
                                                 v-text="'unit' in errors ? errors.unit[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('product_unit_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitProductUnits">Submit</state-button>

            <state-button v-else variant="primary" :click="updateProductUnit">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import StateButton from "../../../../../components/Common/StateButton";

    export default {
        name: "ProductUnitsFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit'
        ],

        data() {
            return {
                loading: true,
                selected: {
                    unit: [],
                },
                units: [
                    {label: 'Carton', value: 'Carton'},
                    {label: 'lb', value: 'lb'},
                    {label: 'Pieces', value: 'Pieces'},
                    {label: 'Box', value: 'Box'},
                    {label: 'Pack', value: 'Pack'},
                    {label: 'Inch', value: 'Inch'},
                ],
            }
        },

        computed: {
            ...mapGetters({
                form: 'getProductUnitsForm',
                errors: 'getProductUnitsErrors',
            })
        },

        watch: {

        },

        mounted() {
            this.loading = false;
        },

        methods: {
            resetForm() {
                this.$store.commit('setProductUnitsForm');

                this.selected.unit = [];
            },

            updateProductUnits(field) {
                if (field) {
                    this.form.unit = field.unit;
                } else {
                    this.form.unit = '';
                }
                'unit_id' in this.errors ? delete this.errors.unit : '';
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            submitProductUnits() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitProductUnits', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new floor!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_unit_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },
            updateProductUnit() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateProductUnit', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the product unit!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('product_unit_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            }
        }
    }
</script>

<style scoped>

</style>
